module.exports = __webpack_public_path__ + "42bbe4eefcde1297b11dc4b6491e9746.ttf";